import { createFileRoute, redirect } from "@tanstack/react-router";

// /blog/{slug} is a legacy URL. /articles/{slug} is the single canonical route
// for every post (static and CMS), so always 301 here — never render content.
export const Route = createFileRoute("/blog_/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/articles/$slug", params: { slug: params.slug }, statusCode: 301 });
  },
});
